import * as React from 'react';
import './DropdownButton.scss';

export type DropdownButtonProps = {
    children: React.ReactNode;
    /** The label which goes on the dropdown button itself. */
    label: React.ReactNode;
    className?: string;
};

type DropdownButtonState = {
    showDropdown: boolean
};

const MOUSE_DOWN_EVENT = 'mousedown';
const ESCAPE_KEY = 'Escape';

export default class DropdownButton extends React.Component<DropdownButtonProps, DropdownButtonState> {

    static defaultProps = {
        className: '',
    };

    private elementRef: HTMLDivElement | null = null;

    constructor(props: DropdownButtonProps) {
        super(props);

        this.state = {
            showDropdown: false
        };

        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.setRef = this.setRef.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentDidMount() {
        document.addEventListener(MOUSE_DOWN_EVENT, this.handleClick);
    }
    componentWillUnmount() {
        document.removeEventListener(MOUSE_DOWN_EVENT, this.handleClick);
    }

    render() {
        const dropdownVisibilityClass = this.state.showDropdown ? 'dropdown-visible' : 'dropdown-hidden';
        return (
            <span className="dropdown-button" ref={this.setRef} onKeyDown={this.handleKeyPress} >
                <button
                    className={this.props.className}
                    onClick={this.toggleVisibility}
                >
                    {this.props.label}
                </button>
                <div
                    className={`dropdown-content ${dropdownVisibilityClass}`}
                    onClick={() => { this.toggleVisibility(false); }}
                >
                    {this.props.children}
                </div>
            </span>
        );
    }

    private toggleVisibility(): void;
    private toggleVisibility(visible: boolean): void;
    /**
     * Sets or toggles the visibility of the dropdown content.
     * @param visible True to make the dropdown content visbile, false to hide it. If left undefined,
     * then the visibility of the dropdown content will be toggled based on its current state.
     */
    private toggleVisibility(visible?: boolean) {
        this.setState({ showDropdown: typeof visible === 'boolean' ? visible : !this.state.showDropdown });
    }

    private handleClick(event: MouseEvent) {
        if (this.elementRef !== null && !this.elementRef.contains(event.target as Node)) {
            this.toggleVisibility(false);
        }
    }

    private handleKeyPress(event: React.KeyboardEvent<HTMLDivElement>): void {
        if (event.key === ESCAPE_KEY) {
            this.toggleVisibility(false);
        }
    }

    private setRef(ref: HTMLDivElement | null): void {
        this.elementRef = ref;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dropdown/DropdownButton.tsx